import request from '@/utils/request'

export function getTodoList(data) {
  return request({ url: '/todo/list', method: 'post', data })
}

export function addTodoItem(data) {
  return request({ url: '/todo/add', method: 'post', data })
}

export function updateTodoItem(data) {
  return request({ url: '/todo/update', method: 'post', data })
}

export function deleteTodoItem(id) {
  return request({ url: '/todo/delete', method: 'post', data: { id } })
}

export function getUncompletedCount() {
  return request({ url: '/todo/uncompletedCount', method: 'post' })
}

export function getTodoMonthCounts(yearMonth) {
  return request({ url: '/todo/monthCounts', method: 'post', data: { yearMonth } })
}
